import { createContext } from "react";
import { lightThemeColors, darkThemeColors, newLightThemeColors } from "../theme/colors";

export const CompanyContext = createContext({
  lightThemeColors,
  darkThemeColors,
  newLightThemeColors,
});
